import { render, staticRenderFns } from "./contentElementPuzzle.vue?vue&type=template&id=1a6453c9&scoped=true"
import script from "./contentElementPuzzle.vue?vue&type=script&lang=js"
export * from "./contentElementPuzzle.vue?vue&type=script&lang=js"
import style0 from "./contentElementPuzzle.vue?vue&type=style&index=0&id=1a6453c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6453c9",
  null
  
)

export default component.exports